<template>
  <div class="leftbar-view elffy-dashboard" :class="{'left-aside-toggle': toggle_aside}">
    <!--Page Container Start Here-->
    <section class="main-container">
      <div class="container-fluid">
        <div class="widget-wrap">
          <div class="widget-header block-header margin-bottom-0 clearfix">
            <div class="pull-left">
              <h3>你參與的專案</h3>
            </div>
          </div>
          <div class="widget-container">
            
          </div>
        </div>
        <div class="widget-wrap">
          <div class="widget-header block-header margin-bottom-0 clearfix">
            <div class="pull-left">
              <h3>進行中的專案</h3>
            </div>
          </div>
          <div class="widget-container">
            
          </div>
        </div>
      </div>
    </section>
    <!--Page Container End Here-->
  </div>
</template>

<script>
import { getCookie, setCookie } from '../../assets/js/elffy_js/cookie.js'

export default {
  name: 'projects_list_board',
  components: {

  },
  data() {
    return {
      
    }
  },
  created() {

  },
  props: ['toggle_aside'],
  computed: {

  },
  methods: {
    
  },
}
</script>




// WEBPACK FOOTER //
// ProjectsListBoard.vue?69d36d9c